import { useEffect, useState } from 'react';
import { Box, Stack } from '@mui/material';
import { TitleDivider } from '@stack/ui/components';
import useTranslation from 'next-translate/useTranslation';

import CarGalleryView from './CarPhotosGallery/CarGalleryView';
import { CarPhotosProps, GalleryPhoto } from './props';
import { StyledTab, StyledTabs } from './styledTab';

// Individual Photo Properties

export const CarPhotos: React.FC<CarPhotosProps> = (props) => {
  const { newCarGallery, carBrand, carTitle } = props;

  // ==================== STATE
  const [imageState, setImageState] = useState<number>(0); //State to set image type
  const [imageList, setImageList] = useState<GalleryPhoto[]>(
    newCarGallery?.Exterior || []
  ); // Current Image List

  // ==================== EFFECTS

  //Handle changing of image list based on Tabs
  useEffect(() => {
    const updateImageList = () => {
      if (imageState === 0) {
        setImageList(newCarGallery?.Exterior || []);
      } else if (imageState === 1) {
        setImageList(newCarGallery?.Interior || []);
      } else if (imageState === 2) {
        setImageList(newCarGallery?.Other || []);
      } else {
        setImageList([]);
      }
    };

    updateImageList();
  }, [imageState, newCarGallery]);

  // ==================== HOOKS
  const { t } = useTranslation('common');

  // ==================== EVENTS
  const onHandleChange = (e: React.SyntheticEvent, newValue: number) => {
    setImageState(newValue);
  };

  // ==================== RENDER
  return (
    <TitleDivider title={t('carDetail.photos')}>
      {/* Main Box */}
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        {/* Top Bar (eg. Exterior, Interior, Others) */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            borderBottom: '1px solid #EDECED',
          }}
        >
          {/* Exterior, if exterior does not exist then don't load total length */}
          <StyledTabs value={imageState} onChange={onHandleChange}>
            {newCarGallery?.Exterior?.length &&
              newCarGallery?.Exterior?.length > 0 && (
                <StyledTab
                  label={`Exterior ${
                    newCarGallery?.Exterior?.length
                      ? `(${newCarGallery?.Exterior?.length})`
                      : ''
                  }`}
                />
              )}
            {newCarGallery?.Interior?.length &&
              newCarGallery?.Interior?.length > 0 && (
                <StyledTab
                  label={`Interior ${
                    newCarGallery?.Interior?.length
                      ? `(${newCarGallery?.Interior?.length})`
                      : ''
                  }`}
                />
              )}
          </StyledTabs>
        </Box>
        {/* Bottom Section (eg. Photos) */}

        <CarGalleryView
          imageList={imageList}
          isLoading={false}
          carBrand={carBrand}
          carTitle={carTitle}
        />
      </Stack>
    </TitleDivider>
  );
};

export default CarPhotos;
